var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isSupported || _setup.isFeatured)?_c('span',{staticClass:"app-level-badge",class:{ 'app-level-badge--supported': _setup.isSupported },attrs:{"title":_setup.badgeTitle}},[_c(_setup.NcIconSvgWrapper,{attrs:{"path":_setup.badgeIcon,"size":20,"inline":""}}),_vm._v("\n\t"+_vm._s(_setup.badgeText)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }